export default __webpack_public_path__ + "f98d7e8a1adadab92262bbf16854a91d.png";